import React from "react";
import styles from "./BoardOfDirectors.module.scss";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { motion } from "framer-motion";

const BoradMemberList = [
  {
    name: "Mr. Ameet Hariani",
    post: "Independent Director- Chairman",
  },
  // {
  //   name: "Mr. Utpal Sheth",
  //   post: "Non Executive - Vice Chairman",
  // },
  {
    name: "Mr. Sivaramakrishnan Iyer",
    post: "Independent Director",
  },
  {
    name: "Ms. Vandana Chamaria",
    post: "Independent Director",
  },
  {
    name: "Mr. Ronnie Talati",
    post: "Independent Director",
  },
 
  {
    name: "Mr. Nikhil Dalal",
    post: "Independent Director",
  },
  {
    name:"Mr. Amit Goela",
    post:"Non-Executive – Non-Independent Director"
  },
  {
    name:"Mr. Vishal Gupta",
    post:"Non-Executive – Non-Independent Director"
  },
  {
    name: "Mr. Rajiv Agarwal",
    post: "Non-Executive – Non-Independent Director",
  },
  {
    name: "Mr. Sandip Weling",
    post: "Whole-time Director",
  },
  {
    name: "Mr. Neeraj Malik",
    post: "Whole-time Director",
  }, 
];
const CommiteeMemberList = [
  {
    name: "Mr. Rajiv Agarwal",
    post: "Chairperson",
  },
  {
    name: "Mr. Ronnie Talati",
    post: "Member",
  },

  {
    name: "Mr. Neeraj Malik",
    post: "Member",
  },
];
const AuditCommiteeList = [
  {
    name: "Mr. Sivaramakrishnan Iyer",
    post: "Chairperson",
  },
  {
    name: "Mr. Ameet Hariani",
    post: "Member",
  },
  {
    name: "Mr. Nikhil Dalal",
    post: "Member",
  }
];

const NominationCommiteeList = [
  {
    name: "Mr. Sivaramakrishnan Iyer",
    post: "Chairperson",
  },
  {
    name: "Mr. Ameet Hariani",
    post: "Member",
  },
  // {
  //   name: "Mr. Utpal Sheth",
  //   post: "Member",
  // },
  {
    name: "Mr. Ronnie Talati",
    post: "Member",
  },
  {
    name:"Mr. Rajiv Agarwal",
    post: "Member",
  },
  {
    name:"Mr. Nikhil Dalal",
    post: "Member",
  }
];
const CorporateCommiteeList = [
  {
    name: "Ms. Vandana Chamaria",
    post: "Chairperson",
  },
  {
    name: "Mr. Ronnie Talati",
    post: "Member",
  },
  {
    name: "Mr. Rajiv Agarwal",
    post: "Member",
  },
  
];
const StakeholderCommiteeList = [
  {
    name: "Mr. Ronnie Talati",
    post: "Chairperson",
  },

  {
    name: "Mr. Nikhil Dalal",
    post: "Member",
  },
  {
    name: "Mr. Rajiv Agarwal",
    post: "Member",
  },
];
const breadcrumb = [
  { title: "Home", link: "/" },
  { title: "Investors", link: "/investors" },
  { title: "Board Of Directors", link: "" },
];

const BoardOfDirectors: React.FC = () => {
  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className={`${styles.BoardOfDirectors} mt-5 p-0`}>
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            <h1 className="heading text-center">Board of Directors</h1>
            <div className="d-flex justify-content-center align-items-center">
            <p className={`subHeading text-center caps ${styles.subHeading}`}>
              Members of the Board
            </p>
            </div>

            <div className="section">
              <div className={`row g-0 justify-content-center ${styles.borderDiv}`}>
                {BoradMemberList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            <div className="mb-4">
            <div className="d-flex justify-content-center align-items-center">

            <p className={`subHeading text-center caps mt-0 ${styles.subHeading}`}>
                Composition of the Committees
              </p>
              </div>
              <div className="mb-4">
            <div className={`${styles.borderDiv}`}>
            <div className={`cardHeading text-center mb-2 mt-4 caps ${styles.subHeadingText}`}>Audit Committee</div>
            
              <div className="row justify-content-center">
                {AuditCommiteeList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
              </div>
            </div>
              
            </div>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            <div className="mb-4">
            <div className={`${styles.borderDiv}`}>
            <div className={`cardHeading text-center mb-2 mt-4 caps ${styles.subHeadingText}`}>
                Nomination and Remuneration Committee
              </div>
              <div className="row justify-content-center">
                {NominationCommiteeList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
              </div>
            </div>

          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
            
          >
            <div className="mb-4">
            <div className={`${styles.borderDiv}`}>
            <div className={`cardHeading text-center mb-2 mt-4 caps ${styles.subHeadingText}`}>                Stakeholders Relationship Committee
              </div>
              <div className="row justify-content-center">
                {StakeholderCommiteeList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
              </div>
              </div>
                       
            
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
          >
                        <div className="mb-4">

             <div className={`${styles.borderDiv}`}>
              <div className={`cardHeading text-center mb-2 mt-4 caps ${styles.subHeadingText}`}>
                Risk Management Committee
              </div>
              <div className="row justify-content-center">
                {CommiteeMemberList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
              </div>
              </div>
           
          
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
            transition={{ duration: 1, ease: "easeInOut" }}
          >
            <div className="section">
            <div className="mb-4">
            <div className={`${styles.borderDiv}`}>
            <div className={`cardHeading text-center mb-2 mt-4 caps ${styles.subHeadingText}`}>
                Corporate Social Responsibility Committee
              </div>
              <div className="row justify-content-center">
                {CorporateCommiteeList.map((items, imgIndex) => (
                  <div
                    key={imgIndex}
                    className={`col-lg-4 col-md-6 col-sm-6 mb-3 d-flex justify-content-center`}
                  >
                    <MemberCard item={items} />
                  </div>
                ))}
              </div>
              </div>
            </div>
            </div>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default BoardOfDirectors;

const MemberCard = ({ item }) => {
  return (
    <div className={`${styles.MemberCard}`}>
      {item.name && <p className={`para ${styles.title}`}>{item.name}</p>}
      {item.post && <p className={`para ${styles.post}`}>{item.post}</p>}
    </div>
  );
};
